import { render, staticRenderFns } from "./menucomponent.vue?vue&type=template&id=b63d2560"
import script from "./menucomponent.vue?vue&type=script&lang=ts"
export * from "./menucomponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports